export const isAddressValid = (address: string) => Boolean(address.trim());

export const isFullnameValid = (fullname: string) => Boolean(fullname.trim());
